import type { ReactNode } from "react";
import { cn } from "@/utils/format";

type Tone = "default" | "primary" | "success" | "warning" | "danger";

export function Badge({
  children,
  tone = "default",
  className,
}: {
  children: ReactNode;
  tone?: Tone;
  className?: string;
}) {
  return (
    <span
      className={cn(
        "badge",
        tone === "primary" && "badge--primary",
        tone === "success" && "badge--success",
        tone === "warning" && "badge--warning",
        tone === "danger" && "badge--danger",
        className
      )}
    >
      {children}
    </span>
  );
}

export function StatusChip({
  label,
  tone = "default",
}: {
  label: string;
  tone?: Tone;
}) {
  const color =
    tone === "success"
      ? "var(--success)"
      : tone === "warning"
        ? "var(--warning)"
        : tone === "danger"
          ? "var(--danger)"
          : tone === "primary"
            ? "var(--primary)"
            : "var(--text-muted)";

  return (
    <span className="status-chip" style={{ color }}>
      <span className="status-chip__dot" aria-hidden />
      {label}
    </span>
  );
}

export function Avatar({
  initials,
  size = "md",
  className,
}: {
  initials: string;
  size?: "md" | "lg";
  className?: string;
}) {
  return (
    <span className={cn("avatar", size === "lg" && "avatar--lg", className)} aria-hidden>
      {initials}
    </span>
  );
}
